import * as React from 'react';
import {useEffect} from 'react';
import Top from "../Top";
import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {styled} from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Modal from '@mui/material/Modal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Chip from '@mui/material/Chip';
import card1 from "../../assets/images/card1.png";
import card2 from "../../assets/images/card2.png";
import api from "../../utils/api";
// @ts-ignore
import InfiniteScroll from "react-infinite-scroller";
import CircularProgress from "@mui/material/CircularProgress";
import zIndex from '@mui/material/styles/zIndex';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 20px)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  '& div :focus-visible':{outline:0} ,
  '& .slick-prev' : {
    left:0,
    zIndex:99
  },
  '& .slick-next' : {
    right:10,
    zIndex:99
  },
  '& .slick-prev:before, .slick-next:before' : {
    fontSize:30,
    color:'#999'
  },

};

// 새로고침 이미지 변경
const ImageArr = [card1, card2,];
const randomImg = Math.floor(Math.random() * ImageArr.length);
const newsTopImg = ImageArr[randomImg];

const HealthNews = () => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [imageList, setImageList] = React.useState<string[]>([]);
  const [loadingImages, setLoadingImagest] = React.useState([{title: '', thumbNail: '', images: [], hashTags: []}]);
    
  useEffect(() => {
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  const handleOpen = (images :any) => {
    setImageList(images);
    setOpen(true);
  }
  const handleClose = () => setOpen(false);
  
  async function getImages(page :any) {
    try {
      setTimeout(() => {
        api.post(`content/readAllCardNews`, { page: page-1 }).then(res => {
          if(res.data.cardNewsList.length < 1){
            setLoading(false);
            return false;
          }
          setLoadingImagest((prev) => prev.concat(res.data.cardNewsList));
        }).catch(function (error) {
          console.log(error)
        });
      }, page-1 === 0 ? 0 : 1000);
    } catch (error) {}
  }

  return (
    <Box>
      <Top title="건강 뉴스" />
      <Container sx={{ p: 0, pb: 10, bgcolor: '#F6F6F6', minWidth:320}}>
        <Box sx={{ p: 0, pt: 1 }}>
          <Grid item sx={{ bgcolor: '#ffdfdf', borderRadius: '0 0 40px 40px', }} >
            <Grid container spacing={2} direction='column' alignItems='center' sx={{ mt: 6 }}>
              <Grid sx={{ width: 300, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
                <Img alt="" src={newsTopImg} sx={{}} />
              </Grid>

              <Grid container item xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>

              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Typography sx={{ display: 'block', fontSize: '16px', fontWeight: 700, color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
          생애주기별 건강검진 잘 챙기고 계시나요?
        </Typography>
        
        <InfiniteScroll
          pageStart={0}
          loadMore={getImages}
          hasMore={true}
          loader={
            // react-infinite-scroller 는 loader 를 자식 배열에 넣으므로 key 가 필요하다
            <Box key="news-loader" sx={{ display: loading ? 'flex' : 'none', textAlign: 'center'}} justifyContent='center' alignContent={'center'}>
              <CircularProgress />
            </Box>
          }
        >
          <Stack direction={'row'} spacing={2} sx={{ pl: 2, pr: 1, pt: 3, }} useFlexGap flexWrap="wrap">
          <Typography sx={{textAlign:'right', fontSize:11, color:'#aaa', ml:'auto',pr:1}}>출처 : 듀얼헬스케어,<a href="https://blog.naver.com/dualhealth_official" title="Dualheathcare" target='_blank' style={{color:'#aaa', textDecoration:'none'}}> https://blog.naver.com/dualhealth_official</a></Typography>
           
            {loadingImages && loadingImages.filter((v :any) => v.title !== '').map((item, index) => (
              <Card key={index} sx={{ width: '47%', borderRadius: '10px' }} onClick={() => handleOpen(item.images ?? [])}>
                <CardMedia
                  sx={{ height: 180 }}
                  image={!item.thumbNail
                      ? undefined   // 빈 값이면 디렉토리 URL 을 이미지로 요청하게 되므로 요청하지 않는다
                      : item.thumbNail.includes("aws")
                        ? item.thumbNail
                        : 'https://file.dualhealth.kr/healthContent/cardNews/' + item.thumbNail}
                  title="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom component="div"
                    sx={{
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: '2',
                      height: 48
                    }}>
                    {item.title}
                  </Typography>
                  <Stack direction="row" spacing={1} overflow={'scroll'}>
                    {/* hashTags 가 없는 항목이 하나라도 오면 목록 전체가 렌더에 실패했다 */}
                    {(item.hashTags ?? []).map((tag, tagIndex) => (
                      <Chip key={tagIndex} size="small" label={tag} />
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </InfiniteScroll>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Slider {...settings}>
              {imageList && imageList.map((item, index) => (
                <Box  sx={{'&:focus-visible':{outline:0} }}>
                  <Img alt="" src={item.includes("aws")
                      ? item
                      : 'https://file.dualhealth.kr/healthContent/cardNews/' + item}  sx={{'&:focus-visible':{outline:0} }} />
                </Box>
              ))}
            </Slider>
          </Box>
        </Modal>
      </Container>

      <Bottom />
    </Box>
  );
}

const noticeBox = {
  mb: 4, ml: 2, mr: 2,
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, }
}

const noticeTitle = {
  fontSize: 14,
  fontWeight: 700,
  color: '#555',
  mb: 1,
  pr: 2,
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}

const noticeDate = {
  fontSize: 12,
  color: '#777'
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const noticeDetail = {
  fontSize: 14,
  color: '#555',
  whiteSpace: 'pre-wrap'
}

export default HealthNews;